import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Plan } from "./plans";

export type RecommendedPlanState = Partial<Plan>;
const recommendedPlansSlice = createSlice({
  name: "recommendedPlan",
  initialState: {} as RecommendedPlanState,
  reducers: {
    updateRecommendedPlan: {
      reducer: (state, action: PayloadAction<RecommendedPlanState>) => {
        // Does have partial updates
        return { ...state, ...action.payload };
      },
      prepare: (plan: RecommendedPlanState) => {
        return {
          payload: {
            ...plan,
            // deprecated properties:
            get duration_in_months() {
              // eslint-disable-next-line no-console
              console.error(
                "duration_in_months is deprecated!\nUse billing_cycle_in_months or getCourseDuration in calculateGoals.js"
              );
              return (plan as any).duration_in_months;
            },
          },
        };
      },
    },
  },
});

export const { updateRecommendedPlan } = recommendedPlansSlice.actions;

export default recommendedPlansSlice.reducer;
